'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalComponent = function (_Component) {
  _inherits(ModalComponent, _Component);

  function ModalComponent() {
    _classCallCheck(this, ModalComponent);

    return _possibleConstructorReturn(this, (ModalComponent.__proto__ || Object.getPrototypeOf(ModalComponent)).apply(this, arguments));
  }

  _createClass(ModalComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          show = _props.show,
          onHide = _props.onHide,
          title = _props.title,
          body = _props.body,
          buttonText = _props.buttonText;


      return _react2.default.createElement(
        _reactBootstrap.Modal,
        { show: show, onHide: onHide, backdrop: 'static' },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          { closeButton: true },
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            title
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          _react2.default.createElement(
            'p',
            null,
            body
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Footer,
          null,
          _react2.default.createElement(
            _reactBootstrap.Button,
            { onClick: onHide, className: 'btn btn-primary button' },
            buttonText
          )
        )
      );
    }
  }]);

  return ModalComponent;
}(_react.Component);

ModalComponent.propTypes = {
  show: _react2.default.PropTypes.bool.isRequired,
  onHide: _react2.default.PropTypes.func.isRequired,
  title: _react2.default.PropTypes.string.isRequired,
  body: _react2.default.PropTypes.string.isRequired,
  buttonText: _react2.default.PropTypes.string
};
ModalComponent.defaultProps = {
  buttonText: 'Close'
};
exports.default = ModalComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/ModalComponent.jsx
// module id = 401
// module chunks = 0